import { maskNumber } from './mask-number';
import { eFormSubmit } from './e-form-submit';
import { watchControl } from './watch-control';

export default {
    maskNumber,
    eFormSubmit,
    watchControl
};
